function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'ramda/src/isEmpty';
import CustomerCareKeys from '../../../../../../locales/keys';
import { IsFetchingOrdersSelector } from '../../../../../../reducers/selectors/order.history.selectors';
import { IsFetchingAccountDetailsSelector } from '../../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { IsCalculatingQuoteSelector, IsShoppingCartLoadingSelector, IsDbssShoppingCart, IsServiceFeatureShoppingCart } from '../../../../../../reducers/selectors/products.order.selectors';
import { IsCreatingModeSelector } from '../create.products.order.wizard.selectors';
import { AMOUNT_TYPES, getSummaryTotalsLabel } from '../../../../../../reducers/helpers/summary.tab.helper';
import { getRetrieveOrderQuoteCountdown } from '../../../../../../reducers/helpers/async.helper';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
var CartItemsController = /*#__PURE__*/function () {
  function CartItemsController($ngRedux) {
    _classCallCheck(this, CartItemsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      AMOUNT_TYPES: AMOUNT_TYPES,
      getSummaryTotalsLabel: getSummaryTotalsLabel,
      getRetrieveOrderQuoteCountdown: getRetrieveOrderQuoteCountdown,
      localeKeys: CustomerCareKeys
    });
  }
  return _createClass(CartItemsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isCalculatingQuote: IsCalculatingQuoteSelector(store),
          isCreatingMode: IsCreatingModeSelector(store),
          isDbss: IsDbss(store),
          isDbssCart: IsDbssShoppingCart(store),
          isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
          isFetchingOrders: IsFetchingOrdersSelector(store),
          isServiceFeatureShoppingCart: IsServiceFeatureShoppingCart(store),
          isShoppingCartLoading: IsShoppingCartLoadingSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, {})(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "hasCartItemsToShow",
    value: function hasCartItemsToShow() {
      return this.viewModel.items.length || this.showReplaceCartItem() || this.showModifyCartItem();
    }
  }, {
    key: "showModifyCartItem",
    value: function showModifyCartItem() {
      return this.viewModel.modifyItem && !isEmpty(this.viewModel.modifyItem);
    }
  }, {
    key: "showReplaceCartItem",
    value: function showReplaceCartItem() {
      return this.viewModel.replaceItem && this.isReplacingOrder;
    }
  }, {
    key: "showCartItems",
    value: function showCartItems() {
      return this.isProductsStep && this.hasCartItemsToShow() || this.hasCartItemsToShow() && this.isAsyncComplete && this.isCheckoutStep;
    }
  }]);
}();
export default {
  bindings: {
    isAsyncComplete: '<?',
    isCheckoutStep: '<?',
    isProductsStep: '<?',
    isModifyingOrder: '<?',
    isReplacingOrder: '<?',
    onEditCartItem: '&',
    onEditedCartItem: '&',
    onPreviewRenewalStatements: '&',
    onRefreshQuote: '&?',
    onRemoveCartItem: '&',
    retrieveOrderQuoteTimestamp: '<?',
    viewModel: '<' // See CartTab in products.order.selector.helper
  },
  controller: CartItemsController,
  template: require('./create.products.order.cart.html')
};